export default __webpack_public_path__ + "static/media/sepa.e7c2c0f6.svg";